<div>
  <div class="section-wrapper">
    <div nz-row class="section-row">
      <div nz-col nzSpan="11" class="section-label">
        Is your business activity a subject to Anti-Money Laundering, Counter-Terrorist Financing and Sanctions control?
      </div>
      <div nz-col nzSpan="13" class="section-value">
        {{aml.subjectToAml ? 'Yes' : 'No'}}
      </div>
    </div>
  </div>

  <ng-container *ngIf="aml.subjectToAml">
    <div class="section-wrapper">
      <div nz-row class="section-row">
        <div nz-col nzSpan="11" class="section-label">
          Business activities
        </div>
        <div nz-col nzSpan="13" class="section-value">
          <ul>
            <li *ngFor="let item of aml.businessActivities">
              {{item}}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="section-wrapper">
      <div nz-row class="section-row">
        <div nz-col nzSpan="11" class="section-label">
          Money Laundering Reporting Officer
        </div>
        <div nz-col nzSpan="13" class="section-value cursor-pointer">
          <a href="#" (click)="showMlroModal(); false;"> {{fullName}}</a>
        </div>
      </div>
    </div>

    <div class="section-wrapper-collapse">
      <nz-collapse nzBordered="false" class="sections-collapse">
        <nz-collapse-panel nzHeader="AML Questionnaire">

          <div class="section-wrapper">
            <div class="question-block">
              <div class="question-title">
                1. What steps has the applicant taken to ensure that MLRO is capable and suitably qualified to undertake the roles and responsibilities as set out in AML Rules of the AFSA? Please provide details
              </div>
              <div class="question-value">
                {{aml.q1StepsMlro}}
              </div>
            </div>
          </div>

          <div class="section-wrapper">
            <div class="question-block">
              <div class="question-title">
                2. The scope and frequency of the AML/CFT reviews or audits
              </div>
              <div class="question-value">
                {{aml.q2ScopeReviews}}
              </div>
            </div>
          </div>

          <div class="section-wrapper">
            <div class="question-block">
              <div class="question-title">
                3. An overview of how the applicant will monitor, detect, and report threshold and suspicious transactions
              </div>
              <div class="question-value">
                {{aml.q3SuspiciousTransactions}}
              </div>
            </div>
          </div>

          <div class="section-wrapper">
            <div class="question-block no-border">
              <div class="question-title">
                4. Training programs and procedures to ensure employees are made aware of their regulatory obligations with regards to AML/CFT
              </div>
              <div class="question-value">
                {{aml.q4TrainingPrograms}}
              </div>
            </div>
          </div>

        </nz-collapse-panel>
      </nz-collapse>
    </div>
  </ng-container>
</div>
